import { render, staticRenderFns } from "./msdk.vue?vue&type=template&id=28781205&"
import script from "./msdk.vue?vue&type=script&lang=js&"
export * from "./msdk.vue?vue&type=script&lang=js&"
import style0 from "./msdk.vue?vue&type=style&index=0&id=28781205&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports